import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormArray, Validators } from "@angular/forms";
import { MemberappBaseComponent } from "../../groupportal-base/groupportal-base.component";
import {
  AcepSSOService,
  GlobalDomOpsService,
  GlobalDataOpsService,
  CommonOperationsService
} from "@acepteam/globalspack";
import {
  ChapterDetails,
  ChapterInfo
} from "../../../../shared/models/chapter-details";
import { Observable, Observer, Subject, Subscription, of } from "rxjs";
import { group } from "@angular/animations";
import {Group, GroupInfo, Invoice} from "../../../../shared/models/group-portal-data.models";

declare var moment: any;
@Component({
	selector: 'invoices-dashboard',
	templateUrl: './invoices-dashboard.component.html'
})

export class InvoicesDashboardComponent extends MemberappBaseComponent {
	@Input() groupInvoices: Invoice[] = [];
	@Input() invoicesDoneProcessing: boolean;
	ngOnInit() { }

	public SantizeDate(date: string): string {
		if(date == "" || date == null) return "";
		return moment(date).format('MM/DD/YYYY');
	}
}